import React, { useEffect, useState } from 'react';
import { useParams } from '../../../../../services/routing/useRouteInfo';
import { HeadingCard } from '../../../../shared/cards/headingCard';
import { NoteCard } from '../../../../shared/cards/noteCard';
import { Button } from '../../../../shared/inputs/button';
import { SelectQuery } from '../../../../shared/inputs/selectQuery';
import { Modal } from '../../../../shared/modal/modal';
import { FormMode, FormView } from '../../../../shared/view/form';
import { CampaignAdhocContactImport } from './campaignAdhocContactImport';

import ReactTimeago from 'react-timeago';
import { css } from '../../../../../services/css';
import styles from './campaignAdhocForm.module.css';


export const CampaignAdhocForm = () => {

    let { id } = useParams();

    const [len, setLen] = useState(id?.split(',')?.length ?? 0);
    const [show, setShow] = useState(false);

    useEffect(() => {
        setLen(id?.split(',')?.length ?? 0);
    }, [id]);

    const getCompletionTimeString = (length = 0) => {
        return <>
            All calls should completed in&nbsp;
            <ReactTimeago date={new Date(Date.now() + (2000 * length) + (60 * 1000))} live={false} />
        </>
    }

    return <>
        <FormView
            ids={id?.split(',').map(i => parseInt(i ?? ''))}
            resourceName={len > 1 ? 'Campaigns' : 'Campaign'}
            processData={d => {
                d.channelID = 1 // Voice;

                return d;
            }}
            nameFunction={r => r?.name}
            restEndpoint='/communications/campaigns/adhocs'
            listLocation='/communications/campaigns'
            formMode={len === 0 ? FormMode.Add : FormMode.Edit}
            actionText='Add & Dial'
            format={{
                'reason': {
                    max: 4000,
                    rows: 4,
                    type: 'textarea',
                },
                'templateId': {
                    label: 'Template',
                    type: 'custom',
                    element: ({setFieldValue, isSubmitting, data, key, values}) => <>
                        <TemplateInput
                            setFieldValue={setFieldValue}
                            isSubmitting={isSubmitting}
                            data={data}
                            len={len}
                            name={key}
                        />

                        <div className={styles.NestedDetails}>
                            {((values['_template'] ?? data.template)?.note) && (
                                <NoteCard
                                    title='Template Note'
                                    editButton={false}
                                    deleteButton={false}
                                    thin={true}
                                >{(values['_template'] ?? data.template)?.note}</NoteCard>
                            )}

                            {((values['_template'] ?? data.template)?.message) && (
                                <p className={styles.MessagePreview}>
                                    <h1>Caller ID</h1>
                                    {(values['_template'] ?? data.template)?.outboundCallerId?.name} {(values['_template'] ?? data.template)?.outboundCallerId?.contact}
                                </p>
                            )}

                            {((values['_template'] ?? data.template)?.message) && (
                                <p className={styles.MessagePreview}>
                                    <h1>Message</h1>
                                    {(values['_template'] ?? data.template)?.message}
                                </p>
                            )}

                        </div>
                    </>,
                    didChange: (data, input) => input.templateId !== null && data.template?.id !== input.templateId,
                    forChangeLog: v => (v['_template'] ?? v.template)?.name,
                },
                'contacts': {
                    type: 'custom',
                    element: ({setFieldValue, isSubmitting, values, key}) => <>

                        <div className={styles.ContactsPreview}>
                            <h1>
                                {(values[key] ?? []).length} contacts selected
                            </h1>

                            <Button
                                className={css(styles.SelectContacts, 'shadow', 'primary')}
                                type='button'
                                style={{marginTop: '8px'}}
                                onClick={() => {setShow(true)}}
                                disabled={isSubmitting}
                            >
                            {(values[key] ?? []).length > 0 ? 'Edit' : 'Select'}
                                &nbsp;Contacts
                            </Button>
                        </div>

                        {(values[key] ?? []).length > 0 && (<>
                            <br />
                            <p>
                                {getCompletionTimeString(values[key].length)}. They will begin immediately once this campaign is added below.
                            </p>
                        </>)}

                        {(values[key] ?? []).length > 2000 && (<>
                            <br />
                            <NoteCard
                                editButton={false}
                                deleteButton={false}
                                thin={true}
                                title='Large Dataset'>
                                More than 2,000 contacts have been selected. Consider if the data could be split into smaller batches.
                            </NoteCard>
                        </>)}

                        <Modal
                            active={show}
                            onClose={() => setShow(false)}
                            header={
                                <HeadingCard subtitle='Import Contacts'>Import Contacts</HeadingCard>
                            }
                            width='1450px'
                            buttons={[]}
                            // Render ahead of time so data isn't cleared when
                            // opening and closing the model
                            aotRendering={true}
                        >
                            <CampaignAdhocContactImport
                                isShown={show}
                                setContacts={(contact) => {
                                    setFieldValue(key, contact);
                                    setShow(false);
                                }}
                             />
                        </Modal>

                    </>
                }
            }}
        />
    </>
}

const TemplateInput = ({setFieldValue, isSubmitting, data, name, len}) => {
    const [value, setValue] = useState(len === 1 ?
            data[0]?.template ?? {}
            : len > 1 ? {id: null, name: '', message: '', outboundCallId: {}, note: ''}
            : {}
        );

    useEffect(() => {
        setFieldValue(name, value?.id ?? null)

        if (!((value?.id ?? null) === null && value?.name === ''))
            setFieldValue('_template', value)
    }, [value]);
    
    return <SelectQuery
        value={value}
        onChange={setValue}
        placeholder={len > 1 && (value?.id ?? null) === null ? '—' : undefined}
        pluralResourceName='Templates'
        restEndpoint='/communications/campaigns/adhocs/templates'
        disabled={isSubmitting}
        allowEmpty={true}
    />
}